import React from "react";
import SystemStatusTable from "../../sub-pages/elements/SystemStatusTable";

import { IconClock, IconHistory, IconBrandWordpress, IconCode, IconPlug, IconPalette } from "@tabler/icons-react";

const systemItems = [
    {
        name: "Response Date",
        value: "2025-03-15 10:00",
        icon: <IconClock size={30} color="var(--bs-info)" />,
    },
    {
        name: "Next Update Date",
        value: "2025-03-16 10:00",
        icon: <IconHistory size={30} color="var(--bs-info)" />,
    },
];

const softwareItems = [
    {
        name: "WordPress",
        icon: <IconBrandWordpress size={30} color="var(--bs-primary)" />,
        current: "5.5",
        currentTitle: "Current Version",
        recommended: "7.2",
        recommendedTitle: "Recommended Version",
        badge: "Check This!",
    },
    {
        name: "PHP",
        icon: <IconCode size={30} color="var(--bs-warning)" />,
        current: "7.2",
        currentTitle: "Current Version",
        recommended: "8.3",
        recommendedTitle: "Recommended Version",
        badge: "Check This!",
    },
    {
        name: "Plugins",
        icon: <IconPlug size={30} color="var(--bs-success)" />,
        current: "10",
        currentTitle: "Installed",
        recommended: "3",
        recommendedTitle: "Recommended Update",
        badge: "Check This!",
    },
    {
        name: "Themes",
        icon: <IconPalette size={30} color="var(--bs-danger)" />,
        current: "4",
        currentTitle: "Installed",
        recommended: "2",
        recommendedTitle: "Recommended Update",
        badge: "Check This!",
    },
];



const ResponseCard = () => {
    const items = [
        {label: 'Response Date', color: 'info', icon: IconClock, value: "2023-07-10 00:01:02" },
        {label: 'Next update should be before', color: 'primary', icon: IconHistory, value: "2023-07-11 01:01:02" },
    ];

    return (
        <div className="owl-stage-outer">
            <div className="owl-stage d-flex flex-wrap" style={{ width: "100%" }}>
                {items.map(({ label, color, icon: IconComponent, value }) => (
                    <div key={label} className="owl-item cloned" style={{ width: "calc(45% - 30px)", margin: "15px", float: "left" }}>
                        <div className={`p-3 bg-hover-light-black border-bottom d-flex align-items-start invoice-user listing-user bg-${color}-subtle rounded-2`}>
                            <IconComponent size={50} color={`var(--bs-${color})`} />
                            <div className="ms-3 d-inline-block w-75">
                                <h6 className="mb-0 invoice-customer">{label}</h6>
                                <span className="fs-3 invoice-id text-truncate text-body-color d-block w-85">{value}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};


const Dashboard = (props) => {
    return <>
        <SystemStatusTable systemItems={systemItems} softwareItems={softwareItems} />
    </>
}

export default Dashboard;
